// global
import _ from 'lodash';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    messages: [],
};

const KEY = 'SNACKBAR';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOCATION_CHANGE: {
            return {
                ...state,
                messages: [],
            };
        }
        case `${KEY}_SHOW`: {
            const message = {
                ...action.payload,
                id: _.uniqueId('snackbar_'),
            };
            return {
                ...state,
                messages: [...state.messages, message],
            };
        }
        case `${KEY}_DISMISS`: {
            return {
                ...state,
                messages: state.messages.filter(message => message.id !== action.payload),
            };
        }
        case `${KEY}_DISMISS_LAST`: {
            return {
                ...state,
                messages: state.messages.slice(1),
            };
        }
        case `${KEY}_CLEAR`: {
            return {
                ...state,
                messages: [],
            };
        }
        default:
            return state;
    }
};

export default reducer;
